import { makeHttpRequest } from "@/shared";

import { mapCalculatedSellingFromServer } from "./mappers/mapCalculatedSellingFromServer";
import { mapSellingAdditionalServiceToServer } from "./mappers/mapSellingAdditionalServiceToServer";

export const removeAdditionalServiceFromSelling = async (
    sessionKey,
    service
) => {
    const response = (
        await makeHttpRequest({
            url: `/stock/builder/${sessionKey}/remove/service`,
            method: "DELETE",
            data: mapSellingAdditionalServiceToServer(service),
        })
    ).data;

    return mapCalculatedSellingFromServer(response.data);
};
